import { useEffect, useRef } from 'react';
export var useOnResize = function (callback, delay) {
    if (delay === void 0) { delay = 0; }
    var timeoutRef = useRef(null);
    var initialTimeoutRef = useRef(null);
    useEffect(function () {
        var handleResize = function () {
            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(function () {
                callback();
                timeoutRef.current = null;
            }, delay);
        };
        // Clear initial timeout if it exists
        if (initialTimeoutRef.current) {
            clearTimeout(initialTimeoutRef.current);
        }
        initialTimeoutRef.current = setTimeout(function () {
            handleResize();
            initialTimeoutRef.current = null;
        }, 300);
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
            // Clear all timeouts on cleanup
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            if (initialTimeoutRef.current) {
                clearTimeout(initialTimeoutRef.current);
                initialTimeoutRef.current = null;
            }
        };
    }, [callback, delay]);
};
